(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["zentein-collection-2"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('zen-collection-quick-add')) {
    customElements.define('zen-collection-quick-add', class extends HTMLElement {
      connectedCallback() {
        this.form = this.querySelector('form');
        this.button = this.querySelector('[data-zen-add]');
        this.label = this.querySelector('[data-zen-add-label]');
        this.status = this.querySelector('[data-zen-add-status]');
        this.root = this.closest('[data-zen-collection2]');
        if (!this.form || !this.button || this.button.disabled) return;
        this.form.addEventListener('submit', this.handleSubmit.bind(this));
      }

      async handleSubmit(event) {
        event.preventDefault();
        if (this.button.disabled || this.button.getAttribute('aria-disabled') === 'true') return;
        const originalLabel = this.root.dataset.addLabel;
        const cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        const formData = new FormData(this.form);
        this.button.setAttribute('aria-disabled', 'true');
        this.button.classList.add('is-loading');
        this.label.textContent = this.root.dataset.addingLabel;
        this.status.textContent = '';

        if (cart && typeof cart.getSectionsToRender === 'function') {
          formData.append('sections', cart.getSectionsToRender().map((section) => section.id));
          formData.append('sections_url', window.location.pathname);
          if (typeof cart.setActiveElement === 'function') cart.setActiveElement(document.activeElement);
        }

        try {
          const response = await fetch(this.form.action, {
            method: 'POST',
            headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/json' },
            body: formData
          });
          const result = await response.json();
          if (!response.ok || result.status) throw new Error(result.description || result.message || this.root.dataset.errorLabel);
          if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
            await publish(PUB_SUB_EVENTS.cartUpdate, {
              source: 'zentein-collection2',
              productVariantId: formData.get('id'),
              cartData: result
            });
          }
          if (cart && typeof cart.renderContents === 'function') cart.renderContents(result);
          if (cart && cart.classList.contains('is-empty')) cart.classList.remove('is-empty');
          this.label.textContent = this.root.dataset.addedLabel;
          this.status.textContent = this.root.dataset.addedLabel;
          this.root.dispatchEvent(new CustomEvent('zentein:collection-add', {
            bubbles: true,
            detail: {
              variantId: formData.get('id'),
              handle: this.closest('[data-product-handle]')?.dataset.productHandle || ''
            }
          }));
          window.setTimeout(() => {
            this.label.textContent = originalLabel;
            this.status.textContent = '';
          }, 2600);
        } catch (error) {
          this.label.textContent = originalLabel;
          this.status.textContent = error.message || this.root.dataset.errorLabel;
        } finally {
          this.button.classList.remove('is-loading');
          this.button.removeAttribute('aria-disabled');
        }
      }
    });
  }

  document.querySelectorAll('[data-zen-collection2]').forEach((root) => {
    if (root.dataset.enhanced === 'true') return;
    root.dataset.enhanced = 'true';
    const track = (event, details = {}) => {
      const payload = { event, collection: root.dataset.collectionHandle || '', ...details };
      window.dataLayer?.push(payload);
      document.dispatchEvent(new CustomEvent(`zentein:${event}`, { detail: payload }));
    };

    root.querySelectorAll('[data-zen-image-toggle]').forEach((button) => {
      button.addEventListener('click', () => {
        const media = button.closest('[data-zen-media]');
        const active = !media.classList.contains('is-alt');
        media.classList.toggle('is-alt', active);
        button.setAttribute('aria-pressed', String(active));
        track('collection_image_toggled', { handle: button.closest('[data-product-handle]')?.dataset.productHandle || '' });
      });
    });

    root.querySelectorAll('[data-zen-product-link]').forEach((link) => {
      link.addEventListener('click', () => track('collection_product_clicked', {
        handle: link.closest('[data-product-handle]')?.dataset.productHandle || '',
        destination: link.getAttribute('href')
      }));
    });

    root.addEventListener('zentein:collection-add', (event) => track('collection_quick_add', event.detail));
    root.querySelectorAll('[data-zen-helper]').forEach((link) => {
      link.addEventListener('click', () => track(`${link.dataset.zenHelper}_clicked`, { destination: link.getAttribute('href') }));
    });
  });

  } catch(e) { console.error(e); }
})();
})();
